import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'; // @ts-expect-error ts-migrate(7016) FIXME: Module not found

import Croppie from 'croppie';
import styled from '../../../components/Theme';
const AvatarCropperWrapper = styled.div.withConfig({
  displayName: "AvatarCropper__AvatarCropperWrapper",
  componentId: "wffl6w-0"
})([".croppie-container{height:300px;margin-bottom:30px;.cr-slider-wrap{margin:8px auto;}.cr-slider{input{overflow:hidden;background-color:$color-calypso;}&::-webkit-slider-thumb{margin-top:-8px;height:20px;width:20px;border-radius:50%;box-shadow:0 0 0 1px rgba($color-slinky,0.3),0 1px 24px 0 rgba($color-monolith,0.08);background:$color-olaf;cursor:pointer;}&::-moz-range-thumb{margin-top:-8px;height:20px;border-radius:50%;box-shadow:0 0 0 1px rgba($color-slinky,0.3),0 1px 24px 0 rgba($color-monolith,0.08);background:$color-olaf;cursor:pointer;}&::-ms-thumb{margin-top:-8px;height:20px;border-radius:50%;box-shadow:0 0 0 1px rgba($color-slinky,0.3),0 1px 24px 0 rgba($color-monolith,0.08);background:$color-olaf;cursor:pointer;}&::-webkit-slider-runnable-track{height:2px;background:$color-battleship;cursor:pointer;}&::-moz-range-track{height:2px;background:$color-battleship;cursor:pointer;}&::-ms-track{height:2px;background:$color-battleship;cursor:pointer;}}}"]);
const AvatarCropper = /*#__PURE__*/forwardRef(({
  url
}, ref) => {
  const [croppieInstance, setCroppieInstance] = useState();
  const [croppieDOMNode, setCroppieDOMNode] = useState();
  useImperativeHandle(ref, () => ({
    getCroppedImage() {
      return croppieInstance.result({
        type: 'blob',
        size: {
          width: 100,
          height: 100
        },
        circle: false
      });
    }

  }));
  useEffect(() => {
    if (!croppieDOMNode) return;
    setCroppieInstance(new Croppie(croppieDOMNode, {
      viewport: {
        width: 200,
        height: 200,
        type: 'circle'
      }
    }));
  }, [croppieDOMNode]);
  useEffect(() => {
    return () => {
      if (croppieInstance) croppieInstance.destroy();
    };
  }, [croppieInstance]);
  useEffect(() => {
    if (croppieInstance && url) croppieInstance.bind({
      url
    });
  }, [url, croppieInstance]);
  return /*#__PURE__*/_jsx(AvatarCropperWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      ref: r => setCroppieDOMNode(r)
    })
  });
});
export default AvatarCropper;